import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import ordersApi from './actions'
import { ordersKeys } from './constants'

const useOrderPackagingReturnReport = (id: number, enabled?: boolean) => {
  const query = useQuery<string, AxiosError>(
    ordersKeys.orderPackagingReturnReport(id),
    () => ordersApi.getOrderPackagingReturnReport(id),
    {
      enabled,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: Number.MAX_SAFE_INTEGER,
    },
  )

  return query
}

export default useOrderPackagingReturnReport
